import Route from "../Route";
import { Switch } from "react-router-dom";

import { PrescricaoCadastro } from "../../pages/optica/prescricao/PrescricaoCadastro";
import { PrescricaoListagem } from "../../pages/optica/prescricao/PrescricaoListagem";

export default function Optica() {
  return (
    <>
      <Switch>
        <Route
          path="/optica/prescricao/listagem"
          component={PrescricaoListagem}
        />
        <Route
          path="/optica/prescricao/cadastro"
          component={PrescricaoCadastro}
        />
      </Switch>
    </>
  );
}
